export default {
    name: "Tên mã khai thác",
    type: "Loại",
    os: "Hệ điều hành",
    cve: "CVE",
    cvss: "CVSS",
    version: "Phiên bản",
    description: "Mô tả",
    created: "Ngày tạo",
    option: 'Tham số',
    SearchEmptyText: 'Tìm theo tên mã khai thác, CVE, loại, hệ điều hành'
};  
